"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_react_1 = require("mobx-react");
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const react_router_dom_1 = require("react-router-dom");
const Icon_1 = __importDefault(require("../../common/js/atoms/Icon"));
const translation_1 = require("../../common/js/helper/translation");
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
const _variables_scss_1 = __importDefault(require("../../scss/_variables.scss"));
const Tooltip_1 = __importDefault(require("../atoms/Tooltip"));
const TooltipPosition_1 = __importDefault(require("../enums/TooltipPosition"));
class MainNavigationItem extends react_1.default.Component {
    render() {
        const { item, active, className, onItemClick } = this.props;
        if (item.loginRequired && null === AuthorizationStore_1.default.user) {
            return null;
        }
        const authorized = AuthorizationStore_1.default.hasAnyScope(item.scope);
        if (item.loginRequired && !!item.hideForbidden && !authorized) {
            return null;
        }
        if (item.loginRequired && !authorized) {
            return (react_1.default.createElement(Tooltip_1.default, { position: TooltipPosition_1.default.rightCenter, label: (0, translation_1.t)('navigation.permission_denied'), visibleAbove: _variables_scss_1.default.menu_breakpoint, className: (0, classnames_1.default)('znd-main-navigation-item', className) },
                react_1.default.createElement("span", { className: "znd-main-navigation-item__icon text-muted" },
                    react_1.default.createElement(Icon_1.default, { name: item.icon })),
                react_1.default.createElement("span", { className: "znd-main-navigation-item__label" }, (0, translation_1.t)(item.title))));
        }
        return (react_1.default.createElement(Tooltip_1.default, { position: TooltipPosition_1.default.rightCenter, label: (0, translation_1.t)(item.title), visibleAbove: _variables_scss_1.default.menu_breakpoint },
            react_1.default.createElement(react_router_dom_1.Link, { to: item.url, className: (0, classnames_1.default)('znd-main-navigation-item', { 'znd-main-navigation-item--active': active }, className), onClick: onItemClick },
                react_1.default.createElement("span", { className: "znd-main-navigation-item__icon" },
                    react_1.default.createElement(Icon_1.default, { name: item.icon })),
                react_1.default.createElement("span", { className: "znd-main-navigation-item__label" }, (0, translation_1.t)(item.title)))));
    }
}
exports.default = (0, react_i18next_1.withTranslation)()((0, mobx_react_1.observer)(MainNavigationItem));
